import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Adicionar token ao header se disponível
api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('usuarioToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const API_ENDPOINTS = {
  CALCULAR_CONSUMO_MANUAL: `${API_BASE_URL}/api/dxf/calcular-consumo-manual`,
  // Adicione outros endpoints aqui conforme necessário
};

export default api;
